<header
  class="fixed top-0 left-0 right-0 z-50 flex items-center gap-sm h-[70px] pl-md pr-sm backdrop-blur-md border-b border-[#D7E4F4]"
  role="banner"
>
  <!-- Logo -->
  <a routerLink="/" class="shrink-0 flex items-center" aria-label="Home">
    <app-logo></app-logo>
  </a>

  <!-- Vertical line next to logo when pinned items exist -->
  @if (pinnedModulesService.hasVisiblePins()) {
    <span class="w-px h-6 border-line border"></span>
  }

  <!-- Pinned Shortcuts -->
  <app-pinned-modules class="shrink-0"></app-pinned-modules>

  <!-- Module Switcher (module / screen context) -->
  <app-module-switcher class="shrink-0"></app-module-switcher>

  <!-- Context breadcrumb (skips home / module / screen already shown in switcher) -->
  @if (contextBreadcrumbs().length > 0) {
    <span class="w-px h-6 border-line border shrink-0 mx-1"></span>
    <nav
      class="flex items-center self-center gap-1.5 sm:gap-2 min-w-0 overflow-x-auto no-scrollbar whitespace-nowrap text-xs leading-none"
      aria-label="Breadcrumb"
    >
      @for (item of contextBreadcrumbs(); track item.id; let idx = $index; let first = $first) {
        @if (!first) {
          <span class="text-light-text shrink-0 select-none">›</span>
        }

        @if (showShipmentBreadcrumbNav(item, idx)) {
          <app-breadcrumb-shipment-nav class="min-w-0 shrink-0"></app-breadcrumb-shipment-nav>
        } @else if (idx === contextBreadcrumbs().length - 1) {
          <span
            class="text-xs text-gray-text truncate max-w-[120px] sm:max-w-[180px] md:max-w-[220px] lg:max-w-none shrink-0"
            [title]="item.isDynamic ? item.itemName : (item.itemName | translate)"
            aria-current="page"
          >
            @if (item.isDynamic) {
              {{ item.itemName }}
            } @else {
              {{ item.itemName | translate }}
            }
          </span>
        } @else {
          <a
            [routerLink]="item.route"
            [class.pointer-events-none]="!item.route"
            (click)="onBreadcrumbClick(item, $event)"
            [title]="item.isDynamic ? item.itemName : (item.itemName | translate)"
            class="text-xs text-gray-text hover:text-secondary transition-colors outline-none widget-focus-ring truncate max-w-[120px] sm:max-w-[180px] md:max-w-[220px] lg:max-w-none shrink-0"
          >
            @if (item.isDynamic) {
              {{ item.itemName }}
            } @else {
              {{ item.itemName | translate }}
            }
          </a>
        }
      }
    </nav>
  }

  <!-- Spacer -->
  <div class="flex-1 min-w-0"></div>

  <!-- Search Trigger -->
  <button
    type="button"
    (mousedown)="$event.preventDefault()"
    (click)="onGlobalSearchClick()"
    class="flex items-center justify-between gap-sm h-9 px-sm rounded-full bg-white shadow-card text-gray-text text-sm font-medium
           hover:scale-105 transition-all outline-none cursor-pointer widget-focus-ring w-48 md:w-60 lg:w-64 shrink-0"
    [attr.aria-label]="'search' | translate"
  >
    <div class="flex items-center gap-sm min-w-0">
      <ic-search
        startColor="var(--color-primary-start-color)"
        endColor="var(--color-primary-end-color)"
        [opacity]="0.6"
      ></ic-search>
      <span class="hidden md:inline truncate">{{ 'search' | translate }}</span>
    </div>
    <kbd class="hidden lg:inline-flex items-center px-1.5 py-0.5 rounded bg-white text-[10px] font-bold text-gray-400 border border-gray-200">
      {{ searchShortcut }}
    </kbd>
  </button>

  <!-- Action Icons -->
  <div class="flex items-center gap-sm shrink-0">

    <!-- Notifications -->
    <button
      type="button"
      (mousedown)="$event.preventDefault()"
      class="w-9 h-9 rounded-full bg-white shadow-card flex items-center justify-center cursor-pointer hover:scale-110 transition-all outline-none widget-focus-ring"
      (click)="onNotificationClick()"
      [matTooltip]="'notifications' | translate"
      matTooltipPosition="below"
    >
      <ic-notification
        startColor="var(--color-primary-start-color)"
        endColor="var(--color-primary-end-color)"
        [opacity]="0.6"
      ></ic-notification>
    </button>

    <!-- Profile -->
    <button
      type="button"
      (mousedown)="$event.preventDefault()"
      class="w-9 h-9 rounded-full bg-white shadow-card flex items-center justify-center cursor-pointer hover:scale-110 transition-all outline-none widget-focus-ring ml-1"
      (click)="onProfileClick()"
      [matTooltip]="'profile' | translate"
      matTooltipPosition="before"
    >
      <ic-user
        startColor="var(--color-primary-start-color)"
        endColor="var(--color-primary-end-color)"
        [opacity]="0.6"
      ></ic-user>
    </button>
  </div>
</header>

<!-- Mega Menu Overlay + Panel -->
@if (navigationState.megaMenuOpen()) {
  <app-mega-menu></app-mega-menu>
}
